import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ProductoComponent} from './producto.component';
import {ProductosListComponent} from './productos-list/productos-list.component';
import {ProductosNovedadesComponent} from './productos-novedades/productos-novedades.component';
import {ProductosOfertasComponent} from './productos-ofertas/productos-ofertas.component';
import {ProductosPoliticaVentaComponent} from './productos-politica-venta/productos-politica-venta.component';
import {MarcasComponent} from "./marcas/marcas.component";
import {ProductosChipsComponent} from "./productos-chips/productos-chips.component";


const routes: Routes = [
  {
    path:'',
    component:ProductoComponent,
    children:[
      {
        path:'',
        component: ProductosListComponent
      },
      {
        path: 'novedades',
        component:ProductosNovedadesComponent
      },
      {
        path: 'tags/:tag',
        component:ProductosChipsComponent
      },
      {
        path: 'ofertas',
        component:ProductosOfertasComponent
      },
      {
        path: 'politicaVenta',
        component:ProductosPoliticaVentaComponent
      },
      {
        path: 'marcas',
        component:MarcasComponent
      },
      {
        path: ':codtext/:codnum',
        loadChildren:()=>import('src/app/core/producto/ver-producto/ver-producto.module').then(m=>m.VerProductoModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductoRoutingModule { }
